/* eslint-disable max-lines */
export const interestAllFields = `
  id
  signature_id
  inserted_at
  submitted_at
  submitted_at_rel
  updated_at

  # ---------- Address Info ----------
  mailing_address_type
  residence_address1
  residence_ste_number
  residence_city
  residence_state
  residence_zip
  mailing_address1
  mailing_ste_number
  mailing_city
  mailing_state
  mailing_zip

  # ---------- Applicant Info Section ----------
  household_count
  household_member_0_first_name
  household_member_0_last_name
  household_member_0_email
  agree_to_org_terms

  # ---------- Household Members Section ----------
  household_count
  applicant_prefered_contact_type

  household_member_1_relation_to_app
  household_member_2_relation_to_app
  household_member_3_relation_to_app
  household_member_4_relation_to_app
  household_member_5_relation_to_app

  household_member_0_gender
  household_member_1_gender
  household_member_2_gender
  household_member_3_gender
  household_member_4_gender
  household_member_5_gender

  household_member_0_no_dob
  household_member_1_no_dob
  household_member_2_no_dob
  household_member_3_no_dob
  household_member_4_no_dob
  household_member_5_no_dob

  household_member_0_primary_phone
  household_member_1_primary_phone
  household_member_2_primary_phone
  household_member_3_primary_phone
  household_member_4_primary_phone
  household_member_5_primary_phone

  household_member_0_primary_phone_type
  household_member_1_primary_phone_type
  household_member_2_primary_phone_type
  household_member_3_primary_phone_type
  household_member_4_primary_phone_type
  household_member_5_primary_phone_type

  household_member_0_primary_phone_ok_to_leave_message
  household_member_1_primary_phone_ok_to_leave_message
  household_member_2_primary_phone_ok_to_leave_message
  household_member_3_primary_phone_ok_to_leave_message
  household_member_4_primary_phone_ok_to_leave_message
  household_member_5_primary_phone_ok_to_leave_message

  household_member_0_secondary_phone
  household_member_0_secondary_phone_type
  household_member_0_secondary_phone_ok_to_leave_message

  household_member_0_no_primary_phone
  household_member_1_no_primary_phone
  household_member_2_no_primary_phone
  household_member_3_no_primary_phone
  household_member_4_no_primary_phone
  household_member_5_no_primary_phone

  household_member_0_no_email
  household_member_1_no_email
  household_member_2_no_email
  household_member_3_no_email
  household_member_4_no_email
  household_member_5_no_email

  household_member_0_student_type
  household_member_1_student_type
  household_member_2_student_type
  household_member_3_student_type
  household_member_4_student_type
  household_member_5_student_type

  household_member_0_occupation
  household_member_1_occupation
  household_member_2_occupation
  household_member_3_occupation
  household_member_4_occupation
  household_member_5_occupation

  household_member_0_is_disabled
  household_member_1_is_disabled
  household_member_2_is_disabled
  household_member_3_is_disabled
  household_member_4_is_disabled
  household_member_5_is_disabled

  # -- TODO reorder
  household_member_0_first_name
  household_member_0_last_name
  household_member_0_email
  household_member_0_dob

  household_member_1_first_name
  household_member_1_last_name
  household_member_1_email
  household_member_1_dob

  household_member_2_first_name
  household_member_2_last_name
  household_member_2_email
  household_member_2_dob

  household_member_3_first_name
  household_member_3_last_name
  household_member_3_email
  household_member_3_dob

  household_member_4_first_name
  household_member_4_last_name
  household_member_4_email
  household_member_4_dob

  household_member_5_first_name
  household_member_5_last_name
  household_member_5_email
  household_member_5_dob

  household_member_0_no_email
  household_member_1_no_email
  household_member_2_no_email
  household_member_3_no_email
  household_member_4_no_email
  household_member_5_no_email

  # ---------- Income Section ----------
  household_gross_annual_income,
  household_is_self_employed
  household_is_employed
  household_is_receiving_unemployment
  household_is_receiving_vet_income
  household_is_receiving_social_security
  household_is_receiving_gifts
  household_is_receiving_periodic_payments
  household_is_receiving_ssi
  household_is_receiving_disability_benefits
  household_is_receiving_public_assistance_income
  household_is_receiving_child_support
  household_is_entitled_to_child_support
  household_is_receiving_alimony
  household_is_receiving_property_income
  household_is_receiving_non_loan_financial_aid
  household_is_receiving_workers_comp
  household_is_receiving_pension
  household_is_receiving_income_not_listed

  household_member_0_net_self_income_0
  household_member_0_net_self_income_1
  household_member_0_net_self_income_2
  household_member_1_net_self_income_0
  household_member_1_net_self_income_1
  household_member_1_net_self_income_2
  household_member_2_net_self_income_0
  household_member_2_net_self_income_1
  household_member_2_net_self_income_2
  household_member_3_net_self_income_0
  household_member_3_net_self_income_1
  household_member_3_net_self_income_2
  household_member_4_net_self_income_0
  household_member_4_net_self_income_1
  household_member_4_net_self_income_2
  household_member_5_net_self_income_0
  household_member_5_net_self_income_1
  household_member_5_net_self_income_2
  household_member_0_employer_0_name
  household_member_0_employer_1_name
  household_member_0_employer_2_name
  household_member_1_employer_0_name
  household_member_1_employer_1_name
  household_member_1_employer_2_name
  household_member_2_employer_0_name
  household_member_2_employer_1_name
  household_member_2_employer_2_name
  household_member_3_employer_0_name
  household_member_3_employer_1_name
  household_member_3_employer_2_name
  household_member_4_employer_0_name
  household_member_4_employer_1_name
  household_member_4_employer_2_name
  household_member_5_employer_0_name
  household_member_5_employer_1_name
  household_member_5_employer_2_name
  household_member_0_employer_0_address
  household_member_0_employer_1_address
  household_member_0_employer_2_address
  household_member_1_employer_0_address
  household_member_1_employer_1_address
  household_member_1_employer_2_address
  household_member_2_employer_0_address
  household_member_2_employer_1_address
  household_member_2_employer_2_address
  household_member_3_employer_0_address
  household_member_3_employer_1_address
  household_member_3_employer_2_address
  household_member_4_employer_0_address
  household_member_4_employer_1_address
  household_member_4_employer_2_address
  household_member_5_employer_0_address
  household_member_5_employer_1_address
  household_member_5_employer_2_address
  household_member_0_employer_0_gross_annual_income
  household_member_0_employer_1_gross_annual_income
  household_member_0_employer_2_gross_annual_income
  household_member_1_employer_0_gross_annual_income
  household_member_1_employer_1_gross_annual_income
  household_member_1_employer_2_gross_annual_income
  household_member_2_employer_0_gross_annual_income
  household_member_2_employer_1_gross_annual_income
  household_member_2_employer_2_gross_annual_income
  household_member_3_employer_0_gross_annual_income
  household_member_3_employer_1_gross_annual_income
  household_member_3_employer_2_gross_annual_income
  household_member_4_employer_0_gross_annual_income
  household_member_4_employer_1_gross_annual_income
  household_member_4_employer_2_gross_annual_income
  household_member_5_employer_0_gross_annual_income
  household_member_5_employer_1_gross_annual_income
  household_member_5_employer_2_gross_annual_income
  household_member_0_employer_0_years_at_job
  household_member_0_employer_1_years_at_job
  household_member_0_employer_2_years_at_job
  household_member_1_employer_0_years_at_job
  household_member_1_employer_1_years_at_job
  household_member_1_employer_2_years_at_job
  household_member_2_employer_0_years_at_job
  household_member_2_employer_1_years_at_job
  household_member_2_employer_2_years_at_job
  household_member_3_employer_0_years_at_job
  household_member_3_employer_1_years_at_job
  household_member_3_employer_2_years_at_job
  household_member_4_employer_0_years_at_job
  household_member_4_employer_1_years_at_job
  household_member_4_employer_2_years_at_job
  household_member_5_employer_0_years_at_job
  household_member_5_employer_1_years_at_job
  household_member_5_employer_2_years_at_job
  household_member_0_gross_annual_unemployment_income
  household_member_1_gross_annual_unemployment_income
  household_member_2_gross_annual_unemployment_income
  household_member_3_gross_annual_unemployment_income
  household_member_4_gross_annual_unemployment_income
  household_member_5_gross_annual_unemployment_income
  household_member_0_gross_annual_vet_income
  household_member_1_gross_annual_vet_income
  household_member_2_gross_annual_vet_income
  household_member_3_gross_annual_vet_income
  household_member_4_gross_annual_vet_income
  household_member_5_gross_annual_vet_income
  household_member_0_gross_annual_work_comp_income
  household_member_1_gross_annual_work_comp_income
  household_member_2_gross_annual_work_comp_income
  household_member_3_gross_annual_work_comp_income
  household_member_4_gross_annual_work_comp_income
  household_member_5_gross_annual_work_comp_income
  household_member_0_gross_annual_pension_income
  household_member_1_gross_annual_pension_income
  household_member_2_gross_annual_pension_income
  household_member_3_gross_annual_pension_income
  household_member_4_gross_annual_pension_income
  household_member_5_gross_annual_pension_income
  household_member_0_gross_annual_unlisted_income_0_source
  household_member_0_gross_annual_unlisted_income_1_source
  household_member_0_gross_annual_unlisted_income_2_source
  household_member_1_gross_annual_unlisted_income_0_source
  household_member_1_gross_annual_unlisted_income_1_source
  household_member_1_gross_annual_unlisted_income_2_source
  household_member_2_gross_annual_unlisted_income_0_source
  household_member_2_gross_annual_unlisted_income_1_source
  household_member_2_gross_annual_unlisted_income_2_source
  household_member_3_gross_annual_unlisted_income_0_source
  household_member_3_gross_annual_unlisted_income_1_source
  household_member_3_gross_annual_unlisted_income_2_source
  household_member_4_gross_annual_unlisted_income_0_source
  household_member_4_gross_annual_unlisted_income_1_source
  household_member_4_gross_annual_unlisted_income_2_source
  household_member_5_gross_annual_unlisted_income_0_source
  household_member_5_gross_annual_unlisted_income_1_source
  household_member_5_gross_annual_unlisted_income_2_source
  household_member_0_gross_annual_unlisted_income_0_value
  household_member_0_gross_annual_unlisted_income_1_value
  household_member_0_gross_annual_unlisted_income_2_value
  household_member_1_gross_annual_unlisted_income_0_value
  household_member_1_gross_annual_unlisted_income_1_value
  household_member_1_gross_annual_unlisted_income_2_value
  household_member_2_gross_annual_unlisted_income_0_value
  household_member_2_gross_annual_unlisted_income_1_value
  household_member_2_gross_annual_unlisted_income_2_value
  household_member_3_gross_annual_unlisted_income_0_value
  household_member_3_gross_annual_unlisted_income_1_value
  household_member_3_gross_annual_unlisted_income_2_value
  household_member_4_gross_annual_unlisted_income_0_value
  household_member_4_gross_annual_unlisted_income_1_value
  household_member_4_gross_annual_unlisted_income_2_value
  household_member_5_gross_annual_unlisted_income_0_value
  household_member_5_gross_annual_unlisted_income_1_value
  household_member_5_gross_annual_unlisted_income_2_value

  household_member_0_gross_annual_social_security_income
  household_member_1_gross_annual_social_security_income
  household_member_2_gross_annual_social_security_income
  household_member_3_gross_annual_social_security_income
  household_member_4_gross_annual_social_security_income
  household_member_5_gross_annual_social_security_income

  household_member_0_gross_annual_gift_income
  household_member_1_gross_annual_gift_income
  household_member_2_gross_annual_gift_income
  household_member_3_gross_annual_gift_income
  household_member_4_gross_annual_gift_income
  household_member_5_gross_annual_gift_income

  household_member_0_gross_annual_ssi_income
  household_member_1_gross_annual_ssi_income
  household_member_2_gross_annual_ssi_income
  household_member_3_gross_annual_ssi_income
  household_member_4_gross_annual_ssi_income
  household_member_5_gross_annual_ssi_income

  household_member_0_gross_annual_disability_benefits_income
  household_member_1_gross_annual_disability_benefits_income
  household_member_2_gross_annual_disability_benefits_income
  household_member_3_gross_annual_disability_benefits_income
  household_member_4_gross_annual_disability_benefits_income
  household_member_5_gross_annual_disability_benefits_income

  household_member_0_gross_annual_public_assistance_income
  household_member_1_gross_annual_public_assistance_income
  household_member_2_gross_annual_public_assistance_income
  household_member_3_gross_annual_public_assistance_income
  household_member_4_gross_annual_public_assistance_income
  household_member_5_gross_annual_public_assistance_income

  household_member_0_gross_annual_entitled_to_child_support_income
  household_member_1_gross_annual_entitled_to_child_support_income
  household_member_2_gross_annual_entitled_to_child_support_income
  household_member_3_gross_annual_entitled_to_child_support_income
  household_member_4_gross_annual_entitled_to_child_support_income
  household_member_5_gross_annual_entitled_to_child_support_income

  household_member_0_gross_annual_child_support_income
  household_member_1_gross_annual_child_support_income
  household_member_2_gross_annual_child_support_income
  household_member_3_gross_annual_child_support_income
  household_member_4_gross_annual_child_support_income
  household_member_5_gross_annual_child_support_income

  household_member_0_gross_annual_alimony_income
  household_member_1_gross_annual_alimony_income
  household_member_2_gross_annual_alimony_income
  household_member_3_gross_annual_alimony_income
  household_member_4_gross_annual_alimony_income
  household_member_5_gross_annual_alimony_income

  household_member_0_gross_annual_periodic_payments_income
  household_member_1_gross_annual_periodic_payments_income
  household_member_2_gross_annual_periodic_payments_income
  household_member_3_gross_annual_periodic_payments_income
  household_member_4_gross_annual_periodic_payments_income
  household_member_5_gross_annual_periodic_payments_income

  household_member_0_gross_annual_property_income
  household_member_1_gross_annual_property_income
  household_member_2_gross_annual_property_income
  household_member_3_gross_annual_property_income
  household_member_4_gross_annual_property_income
  household_member_5_gross_annual_property_income

  household_member_0_gross_annual_non_loan_financial_aid_income
  household_member_1_gross_annual_non_loan_financial_aid_income
  household_member_2_gross_annual_non_loan_financial_aid_income
  household_member_3_gross_annual_non_loan_financial_aid_income
  household_member_4_gross_annual_non_loan_financial_aid_income
  household_member_5_gross_annual_non_loan_financial_aid_income

  # ---------- Assets Section ----------
  household_has_checking_account
  household_has_savings_account
  household_has_revok_trust
  household_has_real_estate
  household_has_stocks_treasuries
  household_has_cd_money_market
  household_has_ira_401k_lump_pension
  household_has_whole_life_policy
  household_has_cash
  household_has_disposed_of_assets
  household_has_assets_not_listed

  household_member_0_checking_0_balance
  household_member_0_checking_1_balance
  household_member_0_checking_2_balance

  household_member_1_checking_0_balance
  household_member_1_checking_1_balance
  household_member_1_checking_2_balance

  household_member_2_checking_0_balance
  household_member_2_checking_1_balance
  household_member_2_checking_2_balance

  household_member_3_checking_0_balance
  household_member_3_checking_1_balance
  household_member_3_checking_2_balance

  household_member_4_checking_0_balance
  household_member_4_checking_1_balance
  household_member_4_checking_2_balance

  household_member_5_checking_0_balance
  household_member_5_checking_1_balance
  household_member_5_checking_2_balance

  household_member_0_checking_0_bank_name
  household_member_0_checking_1_bank_name
  household_member_0_checking_2_bank_name

  household_member_1_checking_0_bank_name
  household_member_1_checking_1_bank_name
  household_member_1_checking_2_bank_name

  household_member_2_checking_0_bank_name
  household_member_2_checking_1_bank_name
  household_member_2_checking_2_bank_name

  household_member_3_checking_0_bank_name
  household_member_3_checking_1_bank_name
  household_member_3_checking_2_bank_name

  household_member_4_checking_0_bank_name
  household_member_4_checking_1_bank_name
  household_member_4_checking_2_bank_name

  household_member_5_checking_0_bank_name
  household_member_5_checking_1_bank_name
  household_member_5_checking_2_bank_name

  household_member_0_checking_0_is_joint_account
  household_member_0_checking_1_is_joint_account
  household_member_0_checking_2_is_joint_account

  household_member_1_checking_0_is_joint_account
  household_member_1_checking_1_is_joint_account
  household_member_1_checking_2_is_joint_account

  household_member_2_checking_0_is_joint_account
  household_member_2_checking_1_is_joint_account
  household_member_2_checking_2_is_joint_account

  household_member_3_checking_0_is_joint_account
  household_member_3_checking_1_is_joint_account
  household_member_3_checking_2_is_joint_account

  household_member_4_checking_0_is_joint_account
  household_member_4_checking_1_is_joint_account
  household_member_4_checking_2_is_joint_account

  household_member_5_checking_0_is_joint_account
  household_member_5_checking_1_is_joint_account
  household_member_5_checking_2_is_joint_account

  household_member_0_checking_0_joint_account_holder_name
  household_member_0_checking_1_joint_account_holder_name
  household_member_0_checking_2_joint_account_holder_name

  household_member_1_checking_0_joint_account_holder_name
  household_member_1_checking_1_joint_account_holder_name
  household_member_1_checking_2_joint_account_holder_name

  household_member_2_checking_0_joint_account_holder_name
  household_member_2_checking_1_joint_account_holder_name
  household_member_2_checking_2_joint_account_holder_name

  household_member_3_checking_0_joint_account_holder_name
  household_member_3_checking_1_joint_account_holder_name
  household_member_3_checking_2_joint_account_holder_name

  household_member_4_checking_0_joint_account_holder_name
  household_member_4_checking_1_joint_account_holder_name
  household_member_4_checking_2_joint_account_holder_name

  household_member_5_checking_0_joint_account_holder_name
  household_member_5_checking_1_joint_account_holder_name
  household_member_5_checking_2_joint_account_holder_name

  household_member_0_savings_0_balance
  household_member_0_savings_1_balance
  household_member_0_savings_2_balance

  household_member_1_savings_0_balance
  household_member_1_savings_1_balance
  household_member_1_savings_2_balance

  household_member_2_savings_0_balance
  household_member_2_savings_1_balance
  household_member_2_savings_2_balance

  household_member_3_savings_0_balance
  household_member_3_savings_1_balance
  household_member_3_savings_2_balance

  household_member_4_savings_0_balance
  household_member_4_savings_1_balance
  household_member_4_savings_2_balance

  household_member_5_savings_0_balance
  household_member_5_savings_1_balance
  household_member_5_savings_2_balance

  household_member_0_savings_0_bank_name
  household_member_0_savings_1_bank_name
  household_member_0_savings_2_bank_name

  household_member_1_savings_0_bank_name
  household_member_1_savings_1_bank_name
  household_member_1_savings_2_bank_name

  household_member_2_savings_0_bank_name
  household_member_2_savings_1_bank_name
  household_member_2_savings_2_bank_name

  household_member_3_savings_0_bank_name
  household_member_3_savings_1_bank_name
  household_member_3_savings_2_bank_name

  household_member_4_savings_0_bank_name
  household_member_4_savings_1_bank_name
  household_member_4_savings_2_bank_name

  household_member_5_savings_0_bank_name
  household_member_5_savings_1_bank_name
  household_member_5_savings_2_bank_name

  household_member_0_savings_0_is_joint_account
  household_member_0_savings_1_is_joint_account
  household_member_0_savings_2_is_joint_account

  household_member_1_savings_0_is_joint_account
  household_member_1_savings_1_is_joint_account
  household_member_1_savings_2_is_joint_account

  household_member_2_savings_0_is_joint_account
  household_member_2_savings_1_is_joint_account
  household_member_2_savings_2_is_joint_account

  household_member_3_savings_0_is_joint_account
  household_member_3_savings_1_is_joint_account
  household_member_3_savings_2_is_joint_account

  household_member_4_savings_0_is_joint_account
  household_member_4_savings_1_is_joint_account
  household_member_4_savings_2_is_joint_account

  household_member_5_savings_0_is_joint_account
  household_member_5_savings_1_is_joint_account
  household_member_5_savings_2_is_joint_account

  household_member_0_savings_0_joint_account_holder_name
  household_member_0_savings_1_joint_account_holder_name
  household_member_0_savings_2_joint_account_holder_name

  household_member_1_savings_0_joint_account_holder_name
  household_member_1_savings_1_joint_account_holder_name
  household_member_1_savings_2_joint_account_holder_name

  household_member_2_savings_0_joint_account_holder_name
  household_member_2_savings_1_joint_account_holder_name
  household_member_2_savings_2_joint_account_holder_name

  household_member_3_savings_0_joint_account_holder_name
  household_member_3_savings_1_joint_account_holder_name
  household_member_3_savings_2_joint_account_holder_name

  household_member_4_savings_0_joint_account_holder_name
  household_member_4_savings_1_joint_account_holder_name
  household_member_4_savings_2_joint_account_holder_name

  household_member_5_savings_0_joint_account_holder_name
  household_member_5_savings_1_joint_account_holder_name
  household_member_5_savings_2_joint_account_holder_name

  household_member_0_revok_trust_value
  household_member_1_revok_trust_value
  household_member_2_revok_trust_value
  household_member_3_revok_trust_value
  household_member_4_revok_trust_value
  household_member_5_revok_trust_value

  household_member_0_real_estate_value
  household_member_1_real_estate_value
  household_member_2_real_estate_value
  household_member_3_real_estate_value
  household_member_4_real_estate_value
  household_member_5_real_estate_value

  household_member_0_stock_bond_treasury_value
  household_member_1_stock_bond_treasury_value
  household_member_2_stock_bond_treasury_value
  household_member_3_stock_bond_treasury_value
  household_member_4_stock_bond_treasury_value
  household_member_5_stock_bond_treasury_value

  household_member_0_brokerage_name
  household_member_1_brokerage_name
  household_member_2_brokerage_name
  household_member_3_brokerage_name
  household_member_4_brokerage_name
  household_member_5_brokerage_name

  household_member_0_cd_money_market_value
  household_member_1_cd_money_market_value
  household_member_2_cd_money_market_value
  household_member_3_cd_money_market_value
  household_member_4_cd_money_market_value
  household_member_5_cd_money_market_value

  household_member_0_cd_money_market_bank_name
  household_member_1_cd_money_market_bank_name
  household_member_2_cd_money_market_bank_name
  household_member_3_cd_money_market_bank_name
  household_member_4_cd_money_market_bank_name
  household_member_5_cd_money_market_bank_name

  household_member_0_cd_money_market_is_joint_account
  household_member_1_cd_money_market_is_joint_account
  household_member_2_cd_money_market_is_joint_account
  household_member_3_cd_money_market_is_joint_account
  household_member_4_cd_money_market_is_joint_account
  household_member_5_cd_money_market_is_joint_account

  household_member_0_cd_money_market_joint_account_holder_name
  household_member_1_cd_money_market_joint_account_holder_name
  household_member_2_cd_money_market_joint_account_holder_name
  household_member_3_cd_money_market_joint_account_holder_name
  household_member_4_cd_money_market_joint_account_holder_name
  household_member_5_cd_money_market_joint_account_holder_name

  household_member_0_ira_401k_lump_pension_balance
  household_member_1_ira_401k_lump_pension_balance
  household_member_2_ira_401k_lump_pension_balance
  household_member_3_ira_401k_lump_pension_balance
  household_member_4_ira_401k_lump_pension_balance
  household_member_5_ira_401k_lump_pension_balance

  household_member_0_ira_401k_lump_pension_bank_name
  household_member_1_ira_401k_lump_pension_bank_name
  household_member_2_ira_401k_lump_pension_bank_name
  household_member_3_ira_401k_lump_pension_bank_name
  household_member_4_ira_401k_lump_pension_bank_name
  household_member_5_ira_401k_lump_pension_bank_name

  household_member_0_ira_401k_lump_pension_is_joint_account
  household_member_1_ira_401k_lump_pension_is_joint_account
  household_member_2_ira_401k_lump_pension_is_joint_account
  household_member_3_ira_401k_lump_pension_is_joint_account
  household_member_4_ira_401k_lump_pension_is_joint_account
  household_member_5_ira_401k_lump_pension_is_joint_account

  household_member_0_ira_401k_lump_pension_joint_account_holder_name
  household_member_1_ira_401k_lump_pension_joint_account_holder_name
  household_member_2_ira_401k_lump_pension_joint_account_holder_name
  household_member_3_ira_401k_lump_pension_joint_account_holder_name
  household_member_4_ira_401k_lump_pension_joint_account_holder_name
  household_member_5_ira_401k_lump_pension_joint_account_holder_name

  household_member_0_whole_life_insurance_value
  household_member_1_whole_life_insurance_value
  household_member_2_whole_life_insurance_value
  household_member_3_whole_life_insurance_value
  household_member_4_whole_life_insurance_value
  household_member_5_whole_life_insurance_value

  household_member_0_cash_value
  household_member_1_cash_value
  household_member_2_cash_value
  household_member_3_cash_value
  household_member_4_cash_value
  household_member_5_cash_value

  household_member_0_disposed_assets_value
  household_member_1_disposed_assets_value
  household_member_2_disposed_assets_value
  household_member_3_disposed_assets_value
  household_member_4_disposed_assets_value
  household_member_5_disposed_assets_value

  household_member_0_assets_not_listed_0_source
  household_member_0_assets_not_listed_1_source
  household_member_0_assets_not_listed_2_source
  household_member_1_assets_not_listed_0_source
  household_member_1_assets_not_listed_1_source
  household_member_1_assets_not_listed_2_source
  household_member_2_assets_not_listed_0_source
  household_member_2_assets_not_listed_1_source
  household_member_2_assets_not_listed_2_source
  household_member_3_assets_not_listed_0_source
  household_member_3_assets_not_listed_1_source
  household_member_3_assets_not_listed_2_source
  household_member_4_assets_not_listed_0_source
  household_member_4_assets_not_listed_1_source
  household_member_4_assets_not_listed_2_source
  household_member_5_assets_not_listed_0_source
  household_member_5_assets_not_listed_1_source
  household_member_5_assets_not_listed_2_source

  household_member_0_assets_not_listed_0_value
  household_member_0_assets_not_listed_1_value
  household_member_0_assets_not_listed_2_value
  household_member_1_assets_not_listed_0_value
  household_member_1_assets_not_listed_1_value
  household_member_1_assets_not_listed_2_value
  household_member_2_assets_not_listed_0_value
  household_member_2_assets_not_listed_1_value
  household_member_2_assets_not_listed_2_value
  household_member_3_assets_not_listed_0_value
  household_member_3_assets_not_listed_1_value
  household_member_3_assets_not_listed_2_value
  household_member_4_assets_not_listed_0_value
  household_member_4_assets_not_listed_1_value
  household_member_4_assets_not_listed_2_value
  household_member_5_assets_not_listed_0_value
  household_member_5_assets_not_listed_1_value
  household_member_5_assets_not_listed_2_value


  # ---------- Housing Section ----------
  applicant_homeless_does_not_have_landlord
  landlord_first_name
  landlord_last_name
  landlord_address1
  landlord_ste_number
  landlord_city
  landlord_state
  landlord_zip
  landlord_primary_phone
  landlord_primary_phone_type
  landlord_ok_to_leave_message
  landlord_has_unknown_phone
  landlord_email
  reason_for_moving
  applicant_total_monthly_rent
  applicant_contribution_to_rent
  is_rent_subsidized
  landlord_has_unknown_address

  # ---------- Contact Section ----------
  contact_deny_information
  contact_name
  contact_email
  contact_relation
  contact_address1
  contact_ste_number
  contact_city
  contact_state
  contact_zip
  contact_primary_phone
  contact_primary_phone_type
  contact_primary_phone_ok_to_leave_message
  contact_secondary_phone
  contact_secondary_phone_type
  contact_secondary_phone_ok_to_leave_message
  contact_reason_receipt
  contact_reason_emergency
  contact_reason_unable_to_contact
  contact_reason_termination_of_rental_assist
  contact_reason_eviction_from_unit
  contact_reason_late_payment_of_rent
  contact_reason_assist_with_recertification
  contact_reason_change_in_lease_terms
  contact_reason_change_in_house_rules
  contact_reason_other

  # ---------- Race and Ethnicity ----------
  household_member_0_ethnic_category
  household_member_1_ethnic_category
  household_member_2_ethnic_category
  household_member_3_ethnic_category
  household_member_4_ethnic_category
  household_member_5_ethnic_category

  household_member_0_race_amer_indian_alaskan_native
  household_member_1_race_amer_indian_alaskan_native
  household_member_2_race_amer_indian_alaskan_native
  household_member_3_race_amer_indian_alaskan_native
  household_member_4_race_amer_indian_alaskan_native
  household_member_5_race_amer_indian_alaskan_native

  household_member_0_race_asian
  household_member_1_race_asian
  household_member_2_race_asian
  household_member_3_race_asian
  household_member_4_race_asian
  household_member_5_race_asian

  household_member_0_race_african_american
  household_member_1_race_african_american
  household_member_2_race_african_american
  household_member_3_race_african_american
  household_member_4_race_african_american
  household_member_5_race_african_american

  household_member_0_race_native_hawaiian_or_other_pac_islander
  household_member_1_race_native_hawaiian_or_other_pac_islander
  household_member_2_race_native_hawaiian_or_other_pac_islander
  household_member_3_race_native_hawaiian_or_other_pac_islander
  household_member_4_race_native_hawaiian_or_other_pac_islander
  household_member_5_race_native_hawaiian_or_other_pac_islander

  household_member_0_race_white
  household_member_1_race_white
  household_member_2_race_white
  household_member_3_race_white
  household_member_4_race_white
  household_member_5_race_white

  household_member_0_race_other
  household_member_1_race_other
  household_member_2_race_other
  household_member_3_race_other
  household_member_4_race_other
  household_member_5_race_other

  household_member_0_race_decline
  household_member_1_race_decline
  household_member_2_race_decline
  household_member_3_race_decline
  household_member_4_race_decline
  household_member_5_race_decline

  # ---------- Additional Info ----------
  household_receives_other_housing_assistance
  applicant_employee_of_nyc
  applicant_had_nyc_housing_involvement
  household_requires_impairment_mobility
  household_requires_impairment_visual
  household_requires_impairment_hearing
  how_did_applicant_hear_about_property
  household_has_housing_authority_voucher
  household_has_pets
  household_receives_other_housing_assistance_subsidy_type

  # ---------- Certification Section ----------
  agree_to_org_terms
  signup_for_haven_newsletter


  # --------------- legacy fields 1
  inserted_at
  submitted_at
  submitted_at_rel
  applicant_first_name
  applicant_last_name
  household_member_0_first_name
  household_member_0_last_name
  applicant_dob
  residence_housing_type
  residence_address1
  residence_ste_number
  residence_city
  residence_state
  residence_zip
  mailing_address1
  mailing_ste_number
  mailing_city
  mailing_state
  mailing_zip
  applicant_phone_primary
  applicant_phone_secondary
  applicant_phone_secondary_ext
  applicant_no_phone
  applicant_email
  applicant_adult_count
  applicant_child_count
  household_count
  unit_size
  unit_size_sro
  unit_size_studio
  unit_size_1br
  unit_size_1br_den
  unit_size_2br
  unit_size_3br
  unit_size_4br
  unit_size_5br
  unit_size_shared
  household_has_housing_authority_voucher
  household_served_in_armed_forces
  household_has_pets
  household_has_special_accommodations
  household_lives_works_in_menlo_park
  household_lives_works_in_south_sf
  household_lives_works_in_san_mateo
  household_lives_works_in_san_carlos
  income_0_source
  income_1_source
  income_2_source
  income_3_source
  income_0_amount
  income_1_amount
  income_2_amount
  income_3_amount
  asset_0_type
  asset_1_type
  asset_2_type
  asset_3_type
  asset_0_amount
  asset_1_amount
  asset_2_amount
  asset_3_amount
  co_applicant_derived
  contact_email
  applicant_prefered_contact_type
  applicant_rental_buy_pref
  extra_info

  property_id
  has_printed
  has_downloaded
  household_pet_description
  house_member_wheelchair
  household_lives_in_palo_alto
  household_works_in_palo_alto
  works_in_palo_alto_site

  household_member_0_citizen_id_type
  household_member_1_citizen_id_type
  household_member_2_citizen_id_type
  household_member_3_citizen_id_type
  household_member_4_citizen_id_type
  household_member_5_citizen_id_type

  household_member_0_citizen_id_result
  household_member_1_citizen_id_result
  household_member_2_citizen_id_result
  household_member_3_citizen_id_result
  household_member_4_citizen_id_result
  household_member_5_citizen_id_result

  household_member_0_ssn_itin_pending_expected_date
  household_member_1_ssn_itin_pending_expected_date
  household_member_2_ssn_itin_pending_expected_date
  household_member_3_ssn_itin_pending_expected_date
  household_member_4_ssn_itin_pending_expected_date
  household_member_5_ssn_itin_pending_expected_date

  household_member_0_social
  household_member_1_social
  household_member_2_social
  household_member_3_social
  household_member_4_social
  household_member_5_social

  household_member_0_tax_id_number
  household_member_1_tax_id_number
  household_member_2_tax_id_number
  household_member_3_tax_id_number
  household_member_4_tax_id_number
  household_member_5_tax_id_number

  household_member_0_dob
  household_member_1_dob
  household_member_2_dob
  household_member_3_dob
  household_member_4_dob
  household_member_5_dob

  household_member_0_age
  household_member_1_age
  household_member_2_age
  household_member_3_age
  household_member_4_age
  household_member_5_age

  household_member_0_gender
  household_member_1_gender
  household_member_2_gender
  household_member_3_gender
  household_member_4_gender
  household_member_5_gender

  household_member_0_gender_pronoun
  household_member_1_gender_pronoun
  household_member_2_gender_pronoun
  household_member_3_gender_pronoun
  household_member_4_gender_pronoun
  household_member_5_gender_pronoun

  household_member_0_ethnic_category
  household_member_1_ethnic_category
  household_member_2_ethnic_category
  household_member_3_ethnic_category
  household_member_4_ethnic_category
  household_member_5_ethnic_category

  household_member_0_race_amer_indian_alaskan_native
  household_member_1_race_amer_indian_alaskan_native
  household_member_2_race_amer_indian_alaskan_native
  household_member_3_race_amer_indian_alaskan_native
  household_member_4_race_amer_indian_alaskan_native
  household_member_5_race_amer_indian_alaskan_native

  household_member_0_race_asian
  household_member_1_race_asian
  household_member_2_race_asian
  household_member_3_race_asian
  household_member_4_race_asian
  household_member_5_race_asian

  household_member_0_race_african_american
  household_member_1_race_african_american
  household_member_2_race_african_american
  household_member_3_race_african_american
  household_member_4_race_african_american
  household_member_5_race_african_american

  household_member_0_race_native_hawaiian_or_other_pac_islander
  household_member_1_race_native_hawaiian_or_other_pac_islander
  household_member_2_race_native_hawaiian_or_other_pac_islander
  household_member_3_race_native_hawaiian_or_other_pac_islander
  household_member_4_race_native_hawaiian_or_other_pac_islander
  household_member_5_race_native_hawaiian_or_other_pac_islander

  household_member_0_race_white
  household_member_1_race_white
  household_member_2_race_white
  household_member_3_race_white
  household_member_4_race_white
  household_member_5_race_white

  household_member_0_race_other
  household_member_1_race_other
  household_member_2_race_other
  household_member_3_race_other
  household_member_4_race_other
  household_member_5_race_other

  household_member_0_race_decline
  household_member_1_race_decline
  household_member_2_race_decline
  household_member_3_race_decline
  household_member_4_race_decline
  household_member_5_race_decline

  household_member_0_income
  household_member_1_income
  household_member_2_income
  household_member_3_income
  household_member_4_income
  household_member_5_income

  household_member_0_relation_to_app
  household_member_1_relation_to_app
  household_member_2_relation_to_app
  household_member_3_relation_to_app
  household_member_4_relation_to_app
  household_member_5_relation_to_app

  household_member_1_first_name
  household_member_2_first_name
  household_member_3_first_name
  household_member_4_first_name
  household_member_5_first_name

  household_member_1_last_name
  household_member_2_last_name
  household_member_3_last_name
  household_member_4_last_name
  household_member_5_last_name

  applicant_first_name
  applicant_last_name
  household_member_0_first_name
  household_member_0_last_name
  residence_housing_type
  residence_address1
  residence_ste_number
  residence_city
  residence_state
  residence_zip
  mailing_address1
  mailing_ste_number
  mailing_city
  mailing_state
  mailing_zip
  applicant_phone_primary
  applicant_phone_secondary
  applicant_phone_secondary_ext
  applicant_no_phone
  applicant_email
  applicant_dob
  applicant_adult_count
  applicant_child_count
  unit_size_studio
  unit_size_1br
  unit_size_1br_den
  unit_size_2br
  household_count
  household_has_housing_authority_voucher
  household_served_in_armed_forces
  household_has_special_accommodations
  house_member_wheelchair
  household_lives_works_in_menlo_park
  household_lives_works_in_south_sf
  household_lives_works_in_san_mateo
  household_works_in_palo_alto
  household_lives_in_palo_alto
  income_0_source
  income_1_source
  income_2_source
  income_3_source
  income_0_amount
  income_1_amount
  income_2_amount
  income_3_amount
  household_member_0_income
  household_member_1_income
  household_member_2_income
  household_member_3_income
  household_member_4_income
  household_member_5_income
  asset_0_type
  asset_1_type
  asset_2_type
  asset_3_type
  asset_0_amount
  asset_1_amount
  asset_2_amount
  asset_3_amount
  co_applicant_derived

  #JSCO
  household_member_0_total_gross_annual_income
  household_member_1_total_gross_annual_income
  household_member_2_total_gross_annual_income
  household_member_3_total_gross_annual_income
  household_member_4_total_gross_annual_income
  household_member_5_total_gross_annual_income

  household_member_0_secondary_phone_ext
  household_member_1_secondary_phone_ext
  household_member_2_secondary_phone_ext
  household_member_3_secondary_phone_ext
  household_member_4_secondary_phone_ext
  household_member_5_secondary_phone_ext

  contact_primary_phone_ext
  contact_secondary_phone_ext

  household_lives_works_in_alameda
  household_all_full_time_students
  household_owns_car

  custom_pref_1
  custom_pref_2
  custom_pref_3
  custom_pref_4
  custom_pref_5
  custom_pref_6
  custom_pref_7
  custom_pref_8
  custom_pref_9
  custom_pref_10
  custom_pref_11
  custom_pref_12
  custom_pref_13
  custom_pref_14

  custom_pref_1_answer
  custom_pref_2_answer
  custom_pref_3_answer
  custom_pref_4_answer
  custom_pref_5_answer
  custom_pref_6_answer
  custom_pref_7_answer
  custom_pref_8_answer
  custom_pref_9_answer
  custom_pref_10_answer
  custom_pref_11_answer
  custom_pref_12_answer
  custom_pref_13_answer
  custom_pref_14_answer

  contact_method_email
  contact_method_phone
  contact_method_mail
  contact_method_sms
  household_disability
  household_disability_answer
  household_gross_annual_income
  pref_move_in_date
  pref_lang
  household_member_0_middle_name
  unit_size
  unit_size_shared
`;
